import * as React from 'react';
import { Container, Typography, List, ListItem, ListItemText } from '@mui/material';

const InstallationDocumentation = () => {
  return (
    <Container sx={{ my: 5 }}>
      <Typography variant="h3" gutterBottom fontWeight={600}>
        MiiraPOS Installation & Setup Guide
      </Typography>

      <Typography variant="h5" gutterBottom mt={4}>
        1. System Requirements
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Windows 10 / Linux (Ubuntu preferred) / Android / iOS" />
        </ListItem>
        <ListItem>
          <ListItemText primary="2 GHz dual-core processor or higher" />
        </ListItem>
        <ListItem>
          <ListItemText primary="4 GB RAM minimum (8 GB recommended)" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Stable internet connection for updates and cloud sync" />
        </ListItem>
      </List>

      <Typography variant="h5" gutterBottom mt={4}>
        2. Installation Steps
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Download MiiraPOS from the official website." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Run the installer on your system (double-click the .exe/.deb/.apk file)." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Follow the on-screen instructions to complete installation." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Launch MiiraPOS and log in with your credentials." />
        </ListItem>
      </List>

      <Typography variant="h5" gutterBottom mt={4}>
        3. Setup Instructions
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Go to Admin Panel → Store Settings." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Configure printer settings, tax preferences, and currency." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Add items to your inventory with barcode and category info." />
        </ListItem>
        <ListItem>
          <ListItemText primary="Set up users and assign roles (Cashier, Manager, Admin)." />
        </ListItem>
      </List>

      <Typography variant="h5" gutterBottom mt={4}>
        4. Support & Help
      </Typography>
      <Typography variant="body1">
        For troubleshooting or integration help, contact us at:
        <br />
        Email: support@miirapos.com
        <br />
      </Typography>
    </Container>
  );
};

export default InstallationDocumentation;
